// import React from "react";
// import { useNavigate } from "react-router-dom";

// import Navbar from "./Navbar";
// import Footer from "./Footer";

// import "./styles/PricingPage.css";

// const pricingPlans = [
//   {
//     title: "Starter",
//     price: "₹249",
//     users: "Best for startups & small teams",
//     features: [
//       "Leave Management",
//       "Profile Management",
//       "Payslips & Documents",
//       "Policy Management",
//       "Event Dashboard",
//       "Dark / Light Mode",
//       "Campus Info",
//     ],
//   },
//   {
//     title: "Growth",
//     price: "₹399",
//     users: "Best for growing businesses & scaling teams",
//   features: [
//   "Everything in Starter",
//   "Goal Setting & OKR Management",
//   "One-on-One Meeting Management",
//   "Automated Workflow Email Notifications",
//   "Reimbursement Request & Approval Management",
//   "Employee Career Growth Pathways",
//   "Quarterly Performance Review Updates",
//   "IT Asset & Support Workflow Management",
//   "Advanced Workforce Analytics & Reports",
//   "Manager Performance Dashboards",
//   "Team Productivity & Insight Tracking",

// ],
//     popular: true,
//   },
//   {
//     title: "Enterprise AI Workplace",
//     price: "₹699+",
//     users: "Best for large enterprises & complex organizations",
// features: [
//   "Everything in Growth",
//   "AI-Powered Workforce Insights & Smart Recommendations",
//   "Custom Workflow Automation & Business Process Configuration",
//   "Multi-Company / Multi-Branch Architecture",
//   "Advanced API Integrations with Third-Party Systems",
//   "Single Sign-On (SSO) & Enterprise Access Control",
//   "Custom Branding & White-Label Experience",
//   "Dedicated Success Manager & Priority Onboarding Support",
//   "Enterprise SLA Support & Priority Issue Resolution",
//   "On-Premise Deployment & Private Infrastructure Hosting",
//   "Advanced Security Controls & Role-Based Permissions",
//   "Custom Dashboard Creation & Executive Reporting",
//   "Compliance Management & Audit Trail Monitoring",
// ],
//   },
// ];
// const PricingPage = () => {
//   const navigate = useNavigate();

//   return (
//     <div className="pricing-page-wrapper">
//       <Navbar />

//       {/* HERO */}
//       <section className="pricing-hero-section">
//         <p className="pricing-mini-title">
//           SIMPLE & FLEXIBLE PRICING
//         </p>

//         <h1 className="pricing-main-title">
//           Pricing Built for <br />
//           Growing Organizations
//         </h1>

//         <p className="pricing-description">
//           Choose a scalable HRMS solution designed
//           for startups, enterprises, and modern teams.
//         </p>
//       </section>

//       {/* CARDS */}
//       <section className="pricing-cards-section">
//         <div className="pricing-grid">
//           {pricingPlans.map((plan, index) => (
//             <div
//               key={index}
//               className={
//                 plan.popular
//                   ? "pricing-card pricing-card-popular"
//                   : "pricing-card"
//               }
//             >
//               {plan.popular && (
//                 <div className="popular-badge">
//                   MOST POPULAR
//                 </div>
//               )}

//               <h2>{plan.title}</h2>

//               <div className="pricing-price">
//                 <span className="price-amount">
//                   {plan.price.split(" / ")[0]}
//                 </span>

//                 <span className="price-duration">
//                   Per User / Month
//                 </span>
//               </div>

//               <p className="pricing-users">
//                 {plan.users}
//               </p>

//               <div className="pricing-features">
//                 {plan.features.map((feature, i) => (
//                   <div
//                     key={i}
//                     className="pricing-feature-item"
//                   >
//                     ✓ {feature}
//                   </div>
//                 ))}
//               </div>

//               <button className="pricing-button">
//                 Get Started
//               </button>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* ENTERPRISE CTA */}
//       <section className="pricing-enterprise-section">
//         <div className="pricing-enterprise-card">
//           <h2>
//             Need Custom Enterprise Solutions?
//           </h2>

//           <p>
//             Contact our team for custom workflows,
//             integrations, security requirements,
//             and enterprise deployment support.
//           </p>

//           <button
//             onClick={() => navigate("/contact")}
//             className="pricing-button"
//           >
//             Contact Sales
//           </button>
//         </div>
//       </section>

//       <Footer />
//     </div>
//   );
// };

// export default PricingPage;



















// import React from "react";
// import { useNavigate , useEffect } from "react-router-dom";

// import Navbar from "./Navbar";
// import Footer from "./Footer";

// import "./styles/PricingPage.css";




// const pricingPlans = [


//   {
//     title: "Starter",
//     price: "₹249",
//     users: "Best for startups & small teams",
//     features: [
//       "Leave Management",
//       "Profile Management",
//       "Payslips & Documents",
//       "Policy Management",
//       "Event Dashboard",
//       "Dark / Light Mode",
//       "Campus Info",
//     ],
//   },
//   {
//     title: "Growth",
//     price: "₹399",
//     users: "Best for growing businesses & scaling teams",
//   features: [
//   "Everything in Starter",
//   "Goal Setting & OKR Management",
//   "One-on-One Meeting Management",
//   "Automated Workflow Email Notifications",
//   "Reimbursement Request & Approval Management",
//   "Employee Career Growth Pathways",
//   "Quarterly Performance Review Updates",
//   "IT Asset & Support Workflow Management",
//   "Advanced Workforce Analytics & Reports",
//   "Manager Performance Dashboards",
//   "Team Productivity & Insight Tracking",

// ],
//     popular: true,
//   },
//   {
//     title: "Enterprise AI Workplace",
//     price: "₹699+",
//     users: "Best for large enterprises & complex organizations",
// features: [
//   "Everything in Growth",
//   "AI-Powered Workforce Insights & Smart Recommendations",
//   "Custom Workflow Automation & Business Process Configuration",
//   "Multi-Company / Multi-Branch Architecture",
//   "Advanced API Integrations with Third-Party Systems",
//   "Single Sign-On (SSO) & Enterprise Access Control",
//   "Custom Branding & White-Label Experience",
//   "Dedicated Success Manager & Priority Onboarding Support",
//   "Enterprise SLA Support & Priority Issue Resolution",
//   "On-Premise Deployment & Private Infrastructure Hosting",
//   "Advanced Security Controls & Role-Based Permissions",
//   "Custom Dashboard Creation & Executive Reporting",
//   "Compliance Management & Audit Trail Monitoring",
// ],
//   },
// ];



// const PricingPage = () => {
//   const navigate = useNavigate();

//   const handleGetStarted = (plan) => {
//     navigate("/plan-checkout", {
//       state: {
//         plan,
//       },
//     });
//   };




//   return (
//     <div className="pricing-page-wrapper">
//       <Navbar />

//       {/* HERO */}
//       <section className="pricing-hero-section">
//         <p className="pricing-mini-title">
//           SIMPLE & FLEXIBLE PRICING
//         </p>

//         <h1 className="pricing-main-title">
//           Pricing Built for <br />
//           Growing Organizations
//         </h1>

//         <p className="pricing-description">
//           Choose a scalable HRMS solution designed
//           for startups, enterprises, and modern teams.
//         </p>
//       </section>

//       {/* CARDS */}
//       <section className="pricing-cards-section">
//         <div className="pricing-grid">
//           {pricingPlans.map((plan, index) => (
//             <div
//               key={index}
//               className={
//                 plan.popular
//                   ? "pricing-card pricing-card-popular"
//                   : "pricing-card"
//               }
//             >
//               {plan.popular && (
//                 <div className="popular-badge">
//                   MOST POPULAR
//                 </div>
//               )}

//               <h2>{plan.title}</h2>

//               <div className="pricing-price">
//                 <div className="price-amount">
//                   {plan.price}
//                 </div>

//                 <div className="price-duration">
//                   Per User / Month
//                 </div>
//               </div>

//               <p className="pricing-users">
//                 {plan.users}
//               </p>

//               <div className="pricing-features">
//                 {plan.features.map((feature, i) => (
//                   <div
//                     key={i}
//                     className="pricing-feature-item"
//                   >
//                     ✓ {feature}
//                   </div>
//                 ))}
//               </div>

//               <button
//                 className="pricing-button"
//                 onClick={() => handleGetStarted(plan)}
//               >
//                 Get Started
//               </button>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* ENTERPRISE CTA */}
//       <section className="pricing-enterprise-section">
//         <div className="pricing-enterprise-card">
//           <h2>
//             Need Custom Enterprise Solutions?
//           </h2>

//           <p>
//             Contact our team for custom workflows,
//             integrations, security requirements,
//             and enterprise deployment support.
//           </p>

//           <button
//   onClick={() => {
//     navigate("/contact");
//     window.scrollTo(0, 0);
//   }}
//   className="pricing-button"
// >
//   Contact Sales
// </button>
//         </div>
//       </section>

//       <Footer />
//     </div>
//   );
// };

// export default PricingPage;













// import React from "react";
// import { useNavigate } from "react-router-dom";

// import Navbar from "./Navbar";
// import Footer from "./Footer";

// import "./styles/PricingPage.css";

// const pricingPlans = [
//   {
//     title: "Starter",
//     price: "₹1",

//     users: "Best for startups & small teams",
//     features: [
//       "Leave Management",
//       "Profile Management",
//       "Payslips & Documents",
//       "Policy Management",
//       "Event Dashboard",
//       "Dark / Light Mode",
//       "Campus Info",
//     ],
//   },
//   {
//     title: "Growth",
//     price: "₹399",
//     users: "Best for growing businesses & scaling teams",
//     features: [
//       "Everything in Starter",
//       "Goal Setting & OKR Management",
//       "One-on-One Meeting Management",
//       "Automated Workflow Email Notifications",
//       "Reimbursement Request & Approval Management",
//       "Employee Career Growth Pathways",
//       "Quarterly Performance Review Updates",
//       "IT Asset & Support Workflow Management",
//       "Advanced Workforce Analytics & Reports",
//       "Manager Performance Dashboards",
//       "Team Productivity & Insight Tracking",
//     ],
//     popular: true,
//   },
//   {
//     title: "Enterprise AI Workplace",
//     price: "₹699+",
//     users: "Best for large enterprises & complex organizations",
//     features: [
//       "Everything in Growth",
//       "AI-Powered Workforce Insights & Smart Recommendations",
//       "Custom Workflow Automation & Business Process Configuration",
//       "Multi-Company / Multi-Branch Architecture",
//       "Advanced API Integrations with Third-Party Systems",
//       "Single Sign-On (SSO) & Enterprise Access Control",
//       "Custom Branding & White-Label Experience",
//       "Dedicated Success Manager & Priority Onboarding Support",
//       "Enterprise SLA Support & Priority Issue Resolution",
//       "On-Premise Deployment & Private Infrastructure Hosting",
//       "Advanced Security Controls & Role-Based Permissions",
//       "Custom Dashboard Creation & Executive Reporting",
//       "Compliance Management & Audit Trail Monitoring",
//     ],
//   },
// ];

// const PricingPage = () => {
//   const navigate = useNavigate();

//   const handleGetStarted = (plan) => {
//     navigate("/plan-checkout", {
//       state: {
//         plan,
//       },
//     });
//   };

//   return (
//     <div className="pricing-page-wrapper">
//       <Navbar />

//       {/* HERO */}
//       <section className="pricing-hero-section">
//         <p className="pricing-mini-title">
//           SIMPLE & FLEXIBLE PRICING
//         </p>

//         <h1 className="pricing-main-title">
//           Pricing Built for <br />
//           Growing Organizations
//         </h1>

//         <p className="pricing-description">
//           Choose a scalable HRMS solution designed
//           for startups, enterprises, and modern teams.
//         </p>
//       </section>

//       {/* CARDS */}
//       <section className="pricing-cards-section">
//         <div className="pricing-grid">
//           {pricingPlans.map((plan, index) => (
//             <div
//               key={index}
//               className={
//                 plan.popular
//                   ? "pricing-card pricing-card-popular"
//                   : "pricing-card"
//               }
//             >
//               {plan.popular && (
//                 <div className="popular-badge">
//                   MOST POPULAR
//                 </div>
//               )}

//               <h2>{plan.title}</h2>

//               <div className="pricing-price">
//                 <div className="price-amount">
//                   {plan.price}
//                 </div>

//                 <div className="price-duration">
//                   Per User / Month
//                 </div>
//               </div>

//               <p className="pricing-users">
//                 {plan.users}
//               </p>

//               <div className="pricing-features">
//                 {plan.features.map((feature, i) => (
//                   <div
//                     key={i}
//                     className="pricing-feature-item"
//                   >
//                     ✓ {feature}
//                   </div>
//                 ))}
//               </div>

//               <button
//                 className="pricing-button"
//                 onClick={() => handleGetStarted(plan)}
//               >
//                 Get Started
//               </button>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* ENTERPRISE CTA */}
//       <section className="pricing-enterprise-section">
//         <div className="pricing-enterprise-card">
//           <h2>
//             Need Custom Enterprise Solutions?
//           </h2>

//           <p>
//             Contact our team for custom workflows,
//             integrations, security requirements,
//             and enterprise deployment support.
//           </p>

//           <button
//             onClick={() => {
//               navigate("/contact");
//               window.scrollTo(0, 0);
//             }}
//             className="pricing-button"
//           >
//             Contact Sales
//           </button>
//         </div>
//       </section>

//       <Footer />
//     </div>
//   );
// };

// export default PricingPage;














// import React from "react";
// import { useNavigate, useLocation } from "react-router-dom";

// import Navbar from "./Navbar";
// import Footer from "./Footer";

// import "./styles/PricingPage.css";

// const pricingPlans = [
//   {
//     title: "Essential",
//     price: "₹1",

//    users: "All-in-One Human Resource Management System",
//     features: [
//       "Employee Management",
//       "Attendance Management",
//       "Leave Management",
//       "Employee Self-Service Portal",
//       "Salary Slips & Document Management",
//       "Employee Bank Details Management",
//       "Policy Management",
//       "Organization Chart",
//       "Campus Information",
//       "Goal Setting & OKR Management",
//       "Performance Review Management",
//       "Probation Evaluation Tracking",
//       "One-on-One Meeting Management",
//       "Task Assignment & Follow-Up Tracking",
//       "Employee Feedback Management",
//       "Manager Performance Dashboards",
//       "Career Growth Pathways",
//       "Employee Recognition & Rewards",
//       "Birthday & Work Anniversary Celebrations",
//       "Festival Greetings & Employee Engagement",
//       "Company Announcements & Updates",
//       "Quarterly Updates & Presentations",
//       "IT Support Request Management",
//       "Equipment Request Management",
//       "Reimbursement Request Management",
//       "Automated Email Notifications",
//       "AI HR Assistant Chatbot",
//       "Advanced Workforce Analytics",
//       "Reports & Insights Dashboard",
//       "Role-Based Access Control",
//       "Dark & Light Mode",

//     ],



//   },
//   {
//     title: "Professional",
//     price: "₹399",
//     users: "GTELINQ HRMS + Intelligent Hiring Hub",
//     features: [
//   "Employee & Workforce Management",
//   "Attendance & Leave Management",
//   "Employee Self-Service Portal",
//   "Salary Slips & Document Management",
//   "Performance Reviews & OKR Management",
//   "Career Growth & Development",
//   "One-on-One Meetings & Feedback",
//   "Employee Recognition & Engagement",
//   "IT Support & Equipment Management",
//   "Reimbursement Management",
//   "Workforce Analytics & Reports",
//   "AI HR Assistant Chatbot",
//   "Role-Based Access Control",
//   "Dark & Light Mode",

//   "AI Candidate Screening",
//   "Resume Scoring & Ranking",
//   "AI Recruitment Assistant",
//   "Automated Candidate Communication",
//   "Technical Assessment Automation",
//   "One-Click Offer Letter Generation",
//   "One-Click Offer Letter Delivery",
//   "Interview Scheduling & Tracking",
//   "Microsoft Teams Calendar Integration",
//   "Dynamic Meeting Link Generation",
//   "Candidate Pipeline Management",
//   "Recruitment Analytics & Hiring Insights"
// ],
//     popular: true,
//   },
//   {
//     title: "Enterprise AI Workplace",
//     price: "₹699+",
//     users: "Best for large enterprises & complex organizations",
//     features: [
//       "Everything in Growth",
//       "AI-Powered Workforce Insights & Smart Recommendations",
//       "Custom Workflow Automation & Business Process Configuration",
//       "Multi-Company / Multi-Branch Architecture",
//       "Advanced API Integrations with Third-Party Systems",
//       "Single Sign-On (SSO) & Enterprise Access Control",
//       "Custom Branding & White-Label Experience",
//       "Dedicated Success Manager & Priority Onboarding Support",
//       "Enterprise SLA Support & Priority Issue Resolution",
//       "On-Premise Deployment & Private Infrastructure Hosting",
//       "Advanced Security Controls & Role-Based Permissions",
//       "Custom Dashboard Creation & Executive Reporting",
//       "Compliance Management & Audit Trail Monitoring",
//     ],
//   },
// ];

// const PricingPage = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const selectedProduct =
//     location.state?.selectedProduct;

//   const handleGetStarted = (plan) => {
//     navigate("/plan-checkout", {
//       state: {
//         plan,
//         product: selectedProduct,
//       },
//     });
//   };

//   return (
//     <div className="pricing-page-wrapper">
//       <Navbar />

//       {/* HERO */}
//       <section className="pricing-hero-section">
//         <p className="pricing-mini-title">
//           SIMPLE & FLEXIBLE PRICING
//         </p>

//         <h1 className="pricing-main-title">
//           Pricing Built for <br />
//           Growing Organizations
//         </h1>

//         <p className="pricing-description">
//           Choose a scalable HRMS solution designed
//           for startups, enterprises, and modern teams.
//         </p>

//         {selectedProduct && (
//           <div
//             style={{
//               marginTop: "25px",
//               display: "inline-block",
//               padding: "12px 20px",
//               background: "rgba(23,211,39,0.12)",
//               border: "1px solid rgba(23,211,39,0.25)",
//               borderRadius: "12px",
//               color: "#17d327",
//               fontWeight: "700",
//             }}
//           >
//             Selected Product: {selectedProduct.name}
//           </div>
//         )}
//       </section>

//       {/* CARDS */}
//       <section className="pricing-cards-section">
//         <div className="pricing-grid">
//           {pricingPlans.map((plan, index) => (
//             <div
//               key={index}
//               className={
//                 plan.popular
//                   ? "pricing-card pricing-card-popular"
//                   : "pricing-card"
//               }
//             >
//               {plan.popular && (
//                 <div className="popular-badge">
//                   MOST POPULAR
//                 </div>
//               )}

//               <h2>{plan.title}</h2>

//               <div className="pricing-price">
//                 <div className="price-amount">
//                   {plan.price}
//                 </div>

//                 <div className="price-duration">
//                   Per User / Month
//                 </div>
//               </div>

//               <p className="pricing-users">
//                 {plan.users}
//               </p>

//               <div className="pricing-features">
//                 {plan.features.map((feature, i) => (
//                   <div
//                     key={i}
//                     className="pricing-feature-item"
//                   >
//                     ✓ {feature}
//                   </div>
//                 ))}
//               </div>

//               <button
//                 className="pricing-button"
//                 onClick={() => handleGetStarted(plan)}
//               >
//                 Get Started
//               </button>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* ENTERPRISE CTA */}
//       <section className="pricing-enterprise-section">
//         <div className="pricing-enterprise-card">
//           <h2>
//             Need Custom Enterprise Solutions?
//           </h2>

//           <p>
//             Contact our team for custom workflows,
//             integrations, security requirements,
//             and enterprise deployment support.
//           </p>

//           <button
//             onClick={() => {
//               navigate("/contact");
//               window.scrollTo(0, 0);
//             }}
//             className="pricing-button"
//           >
//             Contact Sales
//           </button>
//         </div>
//       </section>

//       <Footer />
//     </div>
//   );
// };

// export default PricingPage;



























// import React from "react";
// import { useNavigate, useLocation } from "react-router-dom";

// import Navbar from "./Navbar";
// import Footer from "./Footer";

// import "./styles/PricingPage.css";

// const pricingPlans = [
//   {
//     title: "Essential",
//     price: "₹499",

//     users: "All-in-One Human Resource Management System",
//     features: [
//       "Employee Management",
//       "Attendance Management",
//       "Leave Management",
//       "Employee Self-Service Portal",
//       "Salary Slips & Document Management",
//       "Employee Bank Details Management",
//       "Policy Management",
//       "Organization Chart",
//       "Campus Information",
//       "Goal Setting & OKR Management",
//       "Performance Review Management",
//       "Probation Evaluation Tracking",
//       "One-on-One Meeting Management",
//       "Task Assignment & Follow-Up Tracking",
//       "Employee Feedback Management",
//       "Manager Performance Dashboards",
//       "Career Growth Pathways",
//       "Employee Recognition & Rewards",
//       "Birthday & Work Anniversary Celebrations",
//       "Festival Greetings & Employee Engagement",
//       "Company Announcements & Updates",
//       "Quarterly Updates & Presentations",
//       "IT Support Request Management",
//       "Equipment Request Management",
//       "Reimbursement Request Management",
//       "Automated Email Notifications",
//       "AI HR Assistant Chatbot",
//       "Advanced Workforce Analytics",
//       "Reports & Insights Dashboard",
//       "Role-Based Access Control",
//       "Dark & Light Mode",

//     ],



//   },
//   {
//     title: "Professional",
//     price: "₹799",
//     users: "GTELINQ HRMS + Intelligent Hiring Hub",
//     features: [
//       "Employee & Workforce Management",
//       "Attendance & Leave Management",
//       "Employee Self-Service Portal",
//       "Salary Slips & Document Management",
//       "Performance Reviews & OKR Management",
//       "Career Growth & Development",
//       "One-on-One Meetings & Feedback",
//       "Employee Recognition & Engagement",
//       "IT Support & Equipment Management",
//       "Reimbursement Management",
//       "Workforce Analytics & Reports",
//       "AI HR Assistant Chatbot",
//       "Role-Based Access Control",
//       "Dark & Light Mode",

//       "AI Candidate Screening",
//       "Resume Scoring & Ranking",
//       "AI Recruitment Assistant",
//       "Automated Candidate Communication",
//       "Technical Assessment Automation",
//       "One-Click Offer Letter Generation",
//       "One-Click Offer Letter Delivery",
//       "Interview Scheduling & Tracking",
//       "Microsoft Teams Calendar Integration",
//       "Dynamic Meeting Link Generation",
//       "Candidate Pipeline Management",
//       "Recruitment Analytics & Hiring Insights"
//     ],
//     popular: true,
//   },
//   {
//     title: "Enterprise AI Workplace",
//     price: "",
//     users: "Fully Customizable for Enterprise Workforce Requirements",
//     features: [

//       "AI-Powered Workforce Insights & Smart Recommendations",
//       "Custom Workflow Automation & Business Process Configuration",
//       "Multi-Company / Multi-Branch Architecture",
//       "Advanced API Integrations with Third-Party Systems",
//       "Single Sign-On (SSO) & Enterprise Access Control",
//       "Custom Branding & White-Label Experience",
//       "Dedicated Success Manager & Priority Onboarding Support",
//       "Enterprise SLA Support & Priority Issue Resolution",
//       "On-Premise Deployment & Private Infrastructure Hosting",
//       "Advanced Security Controls & Role-Based Permissions",
//       "Custom Dashboard Creation & Executive Reporting",
//       "Compliance Management & Audit Trail Monitoring",
//     ],
//   },
// ];

// const PricingPage = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const selectedProduct =
//     location.state?.selectedProduct;

//   const handleGetStarted = (plan) => {
//     navigate("/plan-checkout", {
//       state: {
//         plan,
//         product: selectedProduct,
//       },
//     });
//   };

//   return (
//     <div className="pricing-page-wrapper">
//       <Navbar />

//       {/* HERO */}
//       <section className="pricing-hero-section">
//         <p className="pricing-mini-title">
//           SIMPLE & FLEXIBLE PRICING
//         </p>

//         <h1 className="pricing-main-title">
//           Pricing Built for <br />
//           Growing Organizations
//         </h1>

//         <p className="pricing-description">
//           Choose a scalable HRMS solution designed
//           for startups, enterprises, and modern teams.
//         </p>

//         {selectedProduct && (
//           <div
//             style={{
//               marginTop: "25px",
//               display: "inline-block",
//               padding: "12px 20px",
//               background: "rgba(23,211,39,0.12)",
//               border: "1px solid rgba(23,211,39,0.25)",
//               borderRadius: "12px",
//               color: "#17d327",
//               fontWeight: "700",
//             }}
//           >
//             Selected Product: {selectedProduct.name}
//           </div>
//         )}
//       </section>

//       {/* CARDS */}
//       <section className="pricing-cards-section">
//         <div className="pricing-grid">
//           {pricingPlans.map((plan, index) => (
//             <div
//               key={index}
//               className={
//                 plan.popular
//                   ? "pricing-card pricing-card-popular"
//                   : "pricing-card"
//               }
//             >
//               {plan.popular && (
//                 <div className="popular-badge">
//                   MOST POPULAR
//                 </div>
//               )}

//               <h2>{plan.title}</h2>

//               {/* <div className="pricing-price">
//                 <div className="price-amount">
//                   {plan.price}
//                 </div>

//                 <div className="price-duration">
//                   Per User / Month
//                 </div>
//               </div> */}

//               <p className="pricing-users">
//                 {plan.users}
//               </p>

//               <div className="pricing-features">
//                 {plan.features.map((feature, i) => (
//                   <div
//                     key={i}
//                     className="pricing-feature-item"
//                   >
//                     ✓ {feature}
//                   </div>
//                 ))}
//               </div>
//               <div className="pricing-price">
//                 {plan.title === "Enterprise AI Workplace" ? (
//                   <div
//                     className="price-duration"
//                     style={{
//                       fontSize: "18px",
//                       fontWeight: "600",
//                       color: "#17d327",
//                       textAlign: "center",
//                     }}
//                   >
//                     Contact our team for customized pricing
//                   </div>
//                 ) : (
//                   <>
//                     <div className="price-amount">
//                       {plan.price}
//                     </div>

//                     <div className="price-duration">
//                       Per User / Month
//                     </div>
//                   </>
//                 )}
//               </div>

//               <button
//                 className="pricing-button"
//                 onClick={() => handleGetStarted(plan)}
//               >
//                 Get Started
//               </button>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* ENTERPRISE CTA */}
//       <section className="pricing-enterprise-section">
//         <div className="pricing-enterprise-card">
//           <h2>
//             Need Custom Enterprise Solutions?
//           </h2>

//           <p>
//             Contact our team for custom workflows,
//             integrations, security requirements,
//             and enterprise deployment support.
//           </p>

//           <button
//             onClick={() => {
//               navigate("/contact");
//               window.scrollTo(0, 0);
//             }}
//             className="pricing-button"
//           >
//             Contact Sales
//           </button>
//         </div>
//       </section>

//       <Footer />
//     </div>
//   );
// };

// export default PricingPage;


























import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Navbar from "./Navbar";
import Footer from "./Footer";

import "./styles/PricingPage.css";

const pricingPlans = [

  {
    title: "Essential",
    priceINR: 499,
    priceUSD: 6,

    users: "All-in-One Human Resource Management System",
    features: [
      "Employee Management",
      "Attendance Management",
      "Leave Management",
     
      "Salary Slips & Document Management",
      "Employee Bank Details Management",
      
      "Campus Information",
      "Goal Setting & OKR Management",
      "Performance Review Management",
      
      "One-on-One Meeting Management",
      
      "Employee Feedback Management",
      "Manager Performance Dashboards",
      "Career Growth Pathways",
      "Employee Recognition & Rewards",
      "Birthday & Work Anniversary Celebrations",
    
      "Quarterly Updates & Presentations",
      "IT Support Request Management",
      "Equipment Request Management",
      "Reimbursement Request Management",
      "Automated Email Notifications",
      "AI HR Assistant Chatbot",
   
      "Reports & Insights Dashboard",
      "Role-Based Access Control",
      "Dark & Light Mode",

    ],



  },
  {
    title: "Professional",
    priceINR: 799,
    priceUSD: 10,
    users: "GTELINQ HRMS + Intelligent Hiring Hub",
    features: [
      "Employee & Workforce Management",
      "Attendance & Leave Management",
      "Employee Self-Service Portal",
      "Salary Slips & Document Management",
      "Performance Reviews & OKR Management",
     
      "Employee Recognition & Engagement",
      "IT Support & Equipment Management",
      "Reimbursement Management",
    
      "AI HR Assistant Chatbot",
      "Role-Based Access Control",
      

      "AI Candidate Screening",
      "Resume Scoring & Ranking",
      "AI Recruitment Assistant",
      "Automated Candidate Communication",
      "Technical Assessment Automation",
      "One-Click Offer Letter Generation",
      "One-Click Offer Letter Delivery",
      "Interview Scheduling & Tracking",
      "Microsoft Teams Calendar Integration",
      "Dynamic Meeting Link Generation",
      "Candidate Pipeline Management",
      "Recruitment Analytics & Hiring Insights"
    ],
    popular: true,
  },
  {
    title: "Enterprise AI Workplace",
    priceINR: null,
    priceUSD: null,
    users: "Fully Customizable for Enterprise Workforce Requirements",
    features: [

      "AI-Powered Workforce Insights & Smart Recommendations",
      "Custom Workflow Automation & Business Process Configuration",
      "Multi-Company / Multi-Branch Architecture",
      "Advanced API Integrations with Third-Party Systems",
      "Single Sign-On (SSO) & Enterprise Access Control",
      "Custom Branding & White-Label Experience",
      "Dedicated Success Manager & Priority Onboarding Support",
      "Enterprise SLA Support & Priority Issue Resolution",
      "On-Premise Deployment & Private Infrastructure Hosting",
      "Advanced Security Controls & Role-Based Permissions",
      "Custom Dashboard Creation & Executive Reporting",
      "Compliance Management & Audit Trail Monitoring",
    ],
  },
];

const PricingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [country, setCountry] = useState("India");

  const selectedProduct =
    location.state?.selectedProduct;

  const handleGetStarted = (plan) => {
    navigate("/plan-checkout", {
      state: {
        plan,
        product: selectedProduct,
        country,
      },
    });
  };

  return (
    <div className="pricing-page-wrapper">
      <Navbar />



      {/* HERO */}
      <section className="pricing-hero-section">
        <p className="pricing-mini-title">
          SIMPLE & FLEXIBLE PRICING
        </p>




        <h1 className="pricing-main-title">
          Pricing Built for <br />
          Growing Organizations
        </h1>

        <p className="pricing-description">
          Choose a scalable HRMS solution designed
          for startups, enterprises, and modern teams.
        </p>



        {selectedProduct && (
          <div
            style={{
              marginTop: "25px",
              display: "inline-block",
              padding: "12px 20px",
              background: "rgba(23,211,39,0.12)",
              border: "1px solid rgba(23,211,39,0.25)",
              borderRadius: "12px",
              color: "#17d327",
              fontWeight: "700",
            }}
          >
            Selected Product: {selectedProduct.name}
          </div>
        )}
      </section>

      {/* CARDS */}

      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto 20px auto",
          padding: "0 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <button
          onClick={() => navigate("/products")}
          style={{
            padding: "10px 18px",
            borderRadius: "10px",
            border: "1px solid #17d327",
            background: "transparent",
            color: "#17d327",
            fontWeight: "600",
            cursor: "pointer",
            transition: "0.3s",
          }}
        >
          ← Back to Products
        </button>
      </div>

      <section className="pricing-cards-section">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            maxWidth: "1200px",
            margin: "0 auto 30px auto",
            padding: "0 20px",
          }}
        >
          <select
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            style={{
              width: "180px",
              height: "48px",
              borderRadius: "12px",
              border: "1px solid #17d327",
              background: "#000",
              color: "#fff",
              padding: "0 15px",
            }}
          >
            <option
              value="India"
              style={{
                backgroundColor: "#000",
                color: "#fff",
              }}
            >
              India
            </option>

            <option
              value="US"
              style={{
                backgroundColor: "#000",
                color: "#fff",
              }}
            >
              United States
            </option>
          </select>
        </div>
        <div className="pricing-grid">
          {pricingPlans.map((plan, index) => (
            <div
              key={index}
              className={
                plan.popular
                  ? "pricing-card pricing-card-popular"
                  : "pricing-card"
              }
            >
              {plan.popular && (
                <div className="popular-badge">
                  MOST POPULAR
                </div>
              )}

              <h2>{plan.title}</h2>



              <p className="pricing-users">
                {plan.users}
              </p>

              <div className="pricing-features">
                {plan.features.map((feature, i) => (
                  <div
                    key={i}
                    className="pricing-feature-item"
                  >
                    ✓ {feature}
                  </div>
                ))}
              </div>
              <div className="pricing-price">
                {plan.title === "Enterprise AI Workplace" ? (
                  <div
                    className="price-duration"
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      color: "#17d327",
                      textAlign: "center",
                    }}
                  >
                    Contact our team for customized pricing
                  </div>
                ) : (
                  <>
                    <div className="price-amount">
                      {country === "India"
                        ? `₹${plan.priceINR}`
                        : `$${plan.priceUSD}`}
                    </div>

                    <div className="price-duration">
                      Per User / Month
                    </div>
                  </>
                )}
              </div>

              <button
                className="pricing-button"
                onClick={() => handleGetStarted(plan)}
              >
                Get Started
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* ENTERPRISE CTA */}
      <section className="pricing-enterprise-section">
        <div className="pricing-enterprise-card">
          <h2>
            Need Custom Enterprise Solutions?
          </h2>

          <p>
            Contact our team for custom workflows,
            integrations, security requirements,
            and enterprise deployment support.
          </p>

          <button
            onClick={() => {
              navigate("/contact");
              window.scrollTo(0, 0);
            }}
            className="pricing-button"
          >
            Contact Sales
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PricingPage;